export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40')
];

export const server_loads = [0];

export const dictionary = {
		"/": [2],
		"/about": [4],
		"/classroom-name-picker": [5],
		"/contest-winner-picker": [6],
		"/de": [7],
		"/de/wichtel-generator": [8],
		"/directory": [9],
		"/directory/all-wheels": [10],
		"/directory/event": [11],
		"/directory/grade": [12],
		"/directory/location": [13],
		"/directory/subject": [14],
		"/es": [15],
		"/es/generador-amigo-secreto": [16],
		"/faq": [17],
		"/fixture-generator": [18],
		"/fr": [19],
		"/fr/generateur-pere-noel-secret": [20],
		"/name-wheel": [21],
		"/picker-wheel": [~22],
		"/privacy": [23],
		"/pt": [24],
		"/pt/gerador-amigo-secreto": [25],
		"/random-decision-maker": [26],
		"/random-team-generator": [27],
		"/random-wheel-generator": [28],
		"/ruleta": [29],
		"/search": [~30],
		"/secret-santa-generator": [31],
		"/spin-the-wheel-generator": [32],
		"/spin-wheel-app": [33],
		"/spinning-wheel-picker": [34],
		"/subject/contest-winner-picker": [35],
		"/ultimate-name-spinner-guide": [36],
		"/wheel-of-names": [40],
		"/wheel": [37],
		"/wheel/temp": [~39],
		"/wheel/[id]": [~38],
		"/[type]/[slug]": [~3]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';